import { css } from "styled-components";

// Type recipes for the app and the marketing landing
// (docs/LANDING_AZURE_PAPER.md §3 and §12). Title sizes stay with each site;
// these carry the weight, tracking and family that make a title or a label.

// Titles of 20px and up: semibold with the landing's tight tracking
// (-0.023em is -0.6px at the page header's 26px). A plain string as well as
// a css helper, so the global `h1` rule in styles.js can share it.
export const PAGE_TITLE_RULES = `
  font-weight: 600;
  letter-spacing: -0.023em;
`;

export const pageTitle = css`
  ${PAGE_TITLE_RULES}
`;

// Small labels that name a value in the app: the drawer section labels and
// the card labels. Inter (inherited) in sentence case, no trailing colon.
// Not for form labels.
export const valueLabel = css`
  font-size: 12px;
  line-height: 1.5;
  font-weight: 500;
`;

export const MONO_FONT =
  'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace';

// The landing's kickers, section numbers and route code. Landing only: the
// app's labels take `valueLabel`.
export const mono = css`
  font-family: ${MONO_FONT};
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 0.085em;
  text-transform: uppercase;
`;
